var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex flex-column"},[_c('toolbar',{staticClass:"shadow"}),_c('div',{staticClass:"d-flex flex-column flex-fill overflow-hidden main-area bg-light"},[_c('router-view',{staticClass:"overflow-auto h-100"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }